/**
 * The one name-search rule every people list uses (Manpower, the Shifts roster grid, Providers): a person
 * matches when the query is the START of a name part, read as "First Last" or "Last First",
 * case-insensitively. So "smith", "jane", "jane sm" and "smith j" all find Jane Smith, and "rubell" finds
 * Johnson-Rubell — but "bell" does not drag in every Campbell. A blank query matches everyone.
 */
export interface NamedPerson {
  firstName?: string;
  lastName?: string;
}

export const normalizeNameQuery = (query: string | undefined): string => (query ?? '').trim().toLowerCase().replace(/\s+/g, ' ');

export const matchesNameQuery = (person: NamedPerson, query: string | undefined): boolean => {
  const q = normalizeNameQuery(query);
  if (!q) return true;
  const first = (person.firstName ?? '').trim();
  const last = (person.lastName ?? '').trim();
  return [`${first} ${last}`, `${last} ${first}`].some(full => startsAtWordBoundary(full.toLowerCase(), q));
};

/** True when `q` occurs in `text` at the very start or right after a space or hyphen. */
const startsAtWordBoundary = (text: string, q: string): boolean => {
  for (let i = text.indexOf(q); i !== -1; i = text.indexOf(q, i + 1)) {
    if (i === 0 || text[i - 1] === ' ' || text[i - 1] === '-') return true;
  }
  return false;
};
